// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeoText_wrapper__RRykx"};